import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"



//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import FAQ from "../../../components/faq/FAQ"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"


const Faq = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Preguntas Frecuentes sobre Servicios IT</title>
                    <meta name="description" content="Resuelve tus dudas sobre los servicios tecnológicos de CuySoft. Preguntas frecuentes sobre soporte IT, soluciones de software y ciberseguridad en Ecuador." />
                    <meta name="keywords" content="preguntas frecuentes IT, FAQ CuySoft, soporte IT Ecuador, dudas software, ciberseguridad preguntas" />
                    <link rel="canonical" href="https://www.cuysoft.com/faq" />
                    <meta property="og:title" content="Preguntas Frecuentes – CuySoft Ecuador" />
                    <meta property="og:description" content="Resuelve tus dudas sobre servicios tecnológicos, soporte IT y soluciones de software." />
                    <meta property="og:url" content="https://www.cuysoft.com/faq" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="FAQ" />
                {/* PageTitle */}

                {/*faq start*/}
                <div className="faq-que-list pt-150 pb-115 pt-lg-60 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-md-6">
                                <FAQ />
                            </div>
                            <div className="col-md-6">
                                <FAQ />
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5 accordion-style-two justify-content-center mt-70">
                            <div className="col-lg-10 col-md-10">
                                <FAQ />
                            </div>
                        </div>
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12 text-center mb-25">
                                <Link className="theme_btn" to="/faq">Agrega tus Preguntas</Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/*faq end*/}


                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default Faq